// smartshare以及外链的一些方法
import { getPrivatePrivilege, resolveFileAction } from 'js/util/util'
import _$ from 'js/api/getdata.js'

// 外链常量重置
export const SHARE_TYPE = {
  createNewLink: 'createNewLink', // 私有：新建链接
  commonLink: 'commonLink', // 普通外链
  secureLink: 'secureLink', // 安全外链
  smartShare: 'smartShare', // smart
  mgdelivery: 'mgdelivery', // 外链历史
  limitNum: 200, // 限制创建外链的数量
}

/**
 * 外链相关验证部分
 * @param key 外链类型
 * @param data
 */
export async function checkCanCreate(key, data, callback) {
  // 设定状态
  let flag = true
  // 重组数据
  const mixData = {}
  // 定义创建变量
  const arr = []
  switch (key) {
    case SHARE_TYPE.createNewLink: // 私有：新建链接
      break
    case SHARE_TYPE.commonLink: // 普通外链
      arr.push(canCommonDelivery(data))
      arr.push(await checkDeliveryRule(false, false, data, mixData))
      arr.push(await checkDeliveryStatus(data, mixData))
      flag = arr.every((val) => val === true)
      break
    case SHARE_TYPE.secureLink: // 安全外链
      arr.push(canCommonDelivery(data))
      arr.push(await checkDeliveryRule(true, false, data, mixData))
      arr.push(await checkDeliveryStatus(data, mixData))
      flag = arr.every((val) => val === true)
      break
    case SHARE_TYPE.smartShare: // smart(暂时不做)
      arr.push(await checkDeliveryRule(false, true, data, mixData))
      arr.push(await checkDeliveryStatus(data, mixData))
      flag = arr.every((val) => val === true)
      break
    case SHARE_TYPE.mgdelivery: // 历史记录
      break
    default:
      break
  }
  // 返回数据
  callback({ flag, mixData })
}


// ---------------------创建外链之前的安全管控-------------------------

// 文件权限认证
function canCommonDelivery(currentData) {
  let flag = true
  const state = getPrivatePrivilege(resolveFileAction(currentData.access_mode))
  if (!currentData.isDir && state.canUpload && !state.canPreview && !state.canDownload) {
    window.$toast.simpleShow('您只能创建上传链接', 'error')
    flag = false
  }
  return flag
}

/**
 * 安全管控认证
 * @param isSecureDelivery  判断是否为安全外链
 * @param isSmartshare  判断是否为smartshare
 * @param currentData 验证的文件对象
 * @param mixData 组合请求数据
 */
async function checkDeliveryRule(isSecureDelivery = false, isSmartshare = false, currentData, mixData) {
  // 创建请求参数对象
  const param = {
    security: isSecureDelivery ? 1 : 0,
    neid: currentData.neid,
  }
  let flag = false
  // 请求数据
  await _$.getData('getDeliveryRule', param)
    .then((res) => {
      const { data } = res
      if (currentData.delivery_code) {
        flag = true
      }
      if (data.code === 200) {
        mixData.detail = data.content.detail
        // 管控禁止预览 不能创建smartshare
        if (isSmartshare) {
          const tempControlledRule = JSON.parse(data.content.detail)
          if (tempControlledRule.forbiddenPreview) {
            window.$toast.simpleShow('因受到公司更高安全级别的链接安全管控规则限制，无法创建SmartShare', 'warn')
            flag = false
          } else {
            flag = true
          }
        } else {
          flag = true
        }
      }
    }).catch((err) => {
      if (err.response) {
        const error = err.response.data
        if (error.state === 403) {
          if (isSmartshare) {
            window.$toast.simpleShow('因受到公司更高安全级别的链接安全管控规则限制，无法创建SmartShare', 'warn')
            return
          }
          window.$toast.simpleShow(error.message, 'warn')
        }
      }
    })
    // 返回请求的数据
  return flag
}

/**
 * 验证状态
 */
async function checkDeliveryStatus(currentData, mixData) {
  let flag = true
  await _$.getData('getLinkStatus', { neid: currentData.neid })
    .then((res) => {
      mixData.deliveryStatus = res.data
      if (res.data.code === 'the_user_is_been_managed') {
        window.$toast.simpleShow(res.data.message, 'error')
        flag = false
      }
    }).catch((err) => {
      console.log(err)
    })
  return flag
}

// +--------------------创建之前的条目数验证--------------------------------

/**
 * 获取历史链接条数是否超过200
 */
export async function linkNum(currentData, callback, reject) {
  await _$.getData('linkHistory', { neid: currentData.neid }).then((res) => {
    if (res.status == 200) {
      if (res.data.length >= SHARE_TYPE.limitNum) { // 链接总数达到200不能继续创建
        // 提示信息(确认并回调下载)
        window.$confirm.show({
          value: true,
          isShow: true,
          sureBtn: '知道了',
          onlyOne: true,
          title: '提示',
          isDescribe: true,
          describe: '请删除无用链接后再重试创建',
          content: `您在该文件/文件夹创建的链接已达到${SHARE_TYPE.limitNum}个上线`,
        })
        // 抛出关闭dialog
        reject('close')
      } else {
        const isNew = true
        isLinkOdc(currentData).then((res) => {
          if (res.isOdc) {
            // 显示提示数据
            window.$toast.simpleShow(res.errorInfo, 'warn')
          }
          // 操作
          if (typeof callback === 'function') callback({ isNew })
        })
      }
    }
  }).catch((error) => {
    console.log(error)
  })
}


/* 用于链接弹框，后端是在delivery/status接口上做修改 */
/* currentData为当前数据，selectedData为选择数据。在image预览里，currentData可以不是selectedData */
export async function isLinkOdc(currentData, historyLink = false) {
  const selectedData = currentData
  const { delivery_code, neid } = selectedData
  let odc = {
    isOdc: false,
    errorInfo: '',
  }
  if (!historyLink && delivery_code) { // 存在的外链，直接弹出
    return odc
  }
  odc = await _$.getData('getLinkStatus', { neid }).then((res) => odc).catch((err) => {
    if (err.response && err.response.data.code === 'the_user_is_been_managed') {
      odc.isOdc = true
      odc.errorInfo = err.response.data.message
      return odc
    }
  })
  return odc
}
